import { createAvatarUrlFromName } from 'lib/utils'

const GroupInfo = ({
  name,
  identifier,
  usersCount = 0,
  imgClassName = 'mx-2 my-auto w-7 h-7 rounded-full',
  nameId,
}: {
  name: string
  identifier: string
  usersCount?: number
  imgClassName?: string
  nameId?: string
}) => {
  const imgUrl = createAvatarUrlFromName(name)

  return (
    <span className="flex flex-row gap-1 p-1">
      <img alt={name} className={imgClassName} src={imgUrl} />
      <div className="flex flex-col flex-grow my-auto text-gray-600 text-sm">
        <div
          id={nameId}
          className="font-medium"
        >{`${name} (${usersCount})`}</div>
        <div className="text-xs">{identifier}</div>
      </div>
    </span>
  )
}

export default GroupInfo
